import { gql } from "@apollo/client";

import { REFUND_FRAGMENT } from "./fragments";

export const REFUND_CREATE_MUTATION = gql`
  ${REFUND_FRAGMENT}
  mutation RefundCreate($input: RefundCreateInput!) {
    refundCreate(input: $input) {
      ...Refund
    }
  }
`;
